export default "__VITE_ASSET__77940402__"